import { render, staticRenderFns } from "./UserQuery.vue?vue&type=template&id=0c8e13ae"
import script from "./UserQuery.vue?vue&type=script&lang=js"
export * from "./UserQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports